export default __webpack_public_path__ + "static/icon-21-2-ab978cc34eef64f4c225d5ba407f5116.png";